import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BreadcrumbItem } from '../../types';

const breadcrumbState = namespace('breadcrumb');

@Component
export default class Breadcrumb extends Vue {

  @breadcrumbState.State
  items!: BreadcrumbItem[];

  @breadcrumbState.Mutation('updateItems')
  updateItems: any;

  mounted() {
    this.updateBreadcrumb();
  }

  @Watch('$route.path')
  onRoutePathChanged() {
    this.updateBreadcrumb();
  }

  private updateBreadcrumb() {
    this.updateItems(this.$route.meta.breadcrumbs);
  }

}
